export default "__VITE_ASSET__DEgqyCex__"